<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <i class="fa fa-users"></i> {{ $t('adminUser') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="office" :options="officeOptions"></form-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="department" :options="departmentOptions"></form-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="role" :options="roles"></form-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success" v-if="['owner','admin', 'tech', 'account'].includes($store.state.user.role)">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-1">{{  }}</div>
            <div class="col-lg-5">{{ $t('userInfo') }}</div>
            <div class="col-lg-4">{{ $t('desc') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-1">
              <figure  class="c-board-table__avatar">
                <img v-if="item.avatar" :src="item.avatar" class="thumbnail" />
                <img v-else src="/img/default-avatar.png" class="thumbnail" />
              </figure>
            </div>
            <div class="col-lg-5">
              <div>
                <b>{{ $t('name') }}: </b>
                <span>{{ item.name }}</span>
              </div>
              <div>
                <b>{{ $t('email') }}: </b>
                <span v-if="item.email">{{ item.email }}</span>
                <i v-else class="text-secondary small">{{$t("notUpdated")}}</i>
              </div>
              <div>
                <b>{{ $t('phone') }}: </b>
                <span v-if="item.phone">{{ item.phone }}</span>
                <i v-else class="text-secondary small">{{$t("notUpdated")}}</i>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <b>{{ $t('office') }}: </b>
                <span v-if="item.office">{{ item.office }}</span>
                <i v-else class="text-secondary small">{{$t("notUpdated")}}</i>
              </div>
              <div>
                <b>{{ $t('department') }}: </b>
                <span v-if="item.department">{{ item.department.name }}</span>
                <i v-else class="text-secondary small">{{$t("notUpdated")}}</i>
              </div>
              <div v-if="item.forbidCareCount">
                <b>{{$t('forbidCareCount')}}: </b> {{item.forbidCareCount}}
              </div>
              <div v-if="item.forbidCareTime">
                <b>{{$t('forbidCareTime')}}: </b> {{item.forbidCareTime | moment('DD/MM/YYYY HH:mm:ss')}}
              </div>
              <div v-if="item.expireTime">
                <b>{{$t('expireTime')}}: </b> {{item.expireTime | moment('DD/MM/YYYY HH:mm:ss')}}
              </div>
              <div v-if="item.lastLoginTime">
                <b>{{$t('lastLoginTime')}}: </b> {{item.lastLoginTime | moment('DD/MM/YYYY HH:mm:ss')}}
              </div>
              <div v-if="item.pwdTime && item.pwdTime > 0">
                <label class="badge badge-danger">{{$t('pwdLockLabel')}} {{item.pwdTime | moment('DD/MM/YYYY HH:mm:ss') }}</label>
              </div>
              <div>
                <label v-if="item.expireTime && item.expireTime < Date.now()" class="badge badge-danger">{{ $t('expired') }}</label>
                <label v-else-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-else class="badge badge-danger">{{ $t('deactivated') }}</label>
                <label class="badge badge-info ml-1">{{ $t(item.role) }}</label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" v-if="['owner','admin', 'tech', 'operationsManager', 'account'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1" v-if="$store.state.user.role === 'owner'">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>

                    <button @click="unlock(item._id)" type="button" v-if="['owner', 'admin', 'tech', 'agency'].includes($store.state.user.role) && item.pwdTime && item.pwdTime > 0"
                            class="btn btn-sm btn-secondary mr-1" :disabled="saveLoading">
                      <font-awesome-icon icon="key" v-if="!saveLoading"/>
                      <b-spinner v-else small></b-spinner>
                      {{ $t('unlock') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="xl" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col">
          <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
          <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors"></form-input>

<!--          <form-select  :label="$t('group')" :model="formModel" attribute="group" :errors="formErrors" :options="groupOptions"></form-select>-->
          <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
          <form-file :label="$t('avatar')" service="/upload/upload-image" :model="formModel" attribute="avatarImage" :errors="formErrors" accept="image/jpeg,image/jpg" />
        </div>
        <div class="col">
          <form-input :label="$t('email')" :model="formModel" attribute="email" :errors="formErrors" type="email"></form-input>
          <form-input v-if="!formModel._id" :label="$t('password')" :model="formModel" attribute="password"
                      :errors="formErrors" type="password"></form-input>

          <form-select :label="$t('role')" :model="formModel" attribute="role" :errors="formErrors" :options="roleList"></form-select>
          <client-select v-if="formModel.role === 'lookup'" :label="$t('selectCustomerToLookUp')" :model="formModel" attribute="clientToLookUp" :multiple="true" :errors="formErrors"></client-select>
          <form-select :label="$t('office')" :model="formModel" attribute="office" :errors="formErrors" :options="officeOptions"></form-select>
          <form-select :label="$t('department')" :model="formModel" attribute="department" :errors="formErrors" :options="departmentOptions"></form-select>
          <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors" />
        </div>
        <div class="col">
          <form-input :label="$t('forbidCareCount')" :model="formModel" attribute="forbidCareCount" :errors="formErrors"></form-input>
          <form-date-time :label="$t('forbidCareTime')" :model="formModel" attribute="forbidCareTime" :errors="formErrors" format="DD/MM/YYYY HH:mm:ss" placeholder="DD/MM/YYYY HH:mm:ss" />
          <form-date-time :label="$t('expireTime')" :model="formModel" attribute="expireTime" format="DD/MM/YYYY" :errors="formErrors" placeholder="DD/MM/YYYY" />
          <button @click="password(formModel._id)" v-if="formModel._id" type="button"
                  class="btn btn-sm btn-warning mb-2">
            <font-awesome-icon icon="sync-alt"/>&nbsp;{{ $t('resetPassword') }}
          </button>
        </div>
      </div>
    </b-modal>
  </main>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";
import ClientSelect from "@/components/ClientSelect";

export default {
  mixins: [List, CRUD],
  components: {ClientSelect},
  data: function () {
    return {
      saveLoading: false,
      service: '/admin-user',
      defaultFormModel: {
        active: true,
        role: null,
        office: null,
        department: null,
        group: null,
        avatarImage: null,
        categories: [],
        expireTime: null,
        clientToLookUp: []
      },
      defaultFilterFormModel: {
        keyword: null,
        office: null,
        department: null,
        group: null,
        role: null,
      },
      roles: [
        {value: null, text: this.$t('chooseRole')},
        {value: 'owner', text: this.$t('owner')},
        {value: 'admin', text: this.$t('admin')},
        {value: 'tech', text: this.$t('tech')},
        {value: 'accountant', text: this.$t('accountant')},
        {value: 'operationsManager', text: this.$t('operationsManager')},
        {value: 'account', text: 'Account'},
        {value: 'manager', text: this.$t('manager')},
        {value: 'sales', text: this.$t('sales')},
        {value: 'kpiSales', text: this.$t('kpiSales')},
        {value: 'am', text: this.$t('accountManagement')},
        {value: 'salesAssistant', text: this.$t('salesAssistant')},
        {value: 'viewer', text: this.$t('viewer')},
        {value: 'marketing', text: this.$t('marketing')},
        {value: 'marketingManager', text: this.$t('marketingManager')},
        {value: 'ctvCall', text: this.$t('ctvCall')},
        {value: 'lookup', text: this.$t('lookup')},
      ],
      officeOptions: [
        {value: null, text: this.$t('chooseOffice')},
        {value: 'VP Miền Bắc', text: 'VP Miền Bắc'},
        {value: 'VP Miền Nam', text: 'VP Miền Nam'},
      ],
      departmentOptions: [],
      groupOptions: []
    }
  },
  watch: {
    "formModel.department": function () {
      this.formModel.group = null;
    }
  },
  computed: {
    roleList() {
      let list = [
        {value: null, text: this.$t('chooseRole')},
        {value: 'tech', text: this.$t('tech')},
        {value: 'account', text: 'Account'},
        {value: 'accountant', text: this.$t('accountant')},
        {value: 'manager', text: this.$t('manager')},
        {value: 'sales', text: this.$t('businessDevelopment')},
        {value: 'kpiSales', text: this.$t('kpiSales')},
        {value: 'am', text: this.$t('accountManagement')},
        {value: 'salesAssistant', text: this.$t('salesAssistant')},
        {value: 'viewer', text: this.$t('viewer')},
        {value: 'agency', text: this.$t('agency')},
        {value: 'marketing', text: this.$t('marketing')},
        {value: 'marketingManager', text: this.$t('marketingManager')},
        {value: 'ctvCall', text: this.$t('ctvCall')},
        {value: 'lookup', text: this.$t('lookup')}
      ]
      if (this.$store.state.user.role === 'owner') {
        list.push(
            {value: 'owner', text: this.$t('owner')},
            {value: 'admin', text: this.$t('admin')},
            {value: 'operationsManager', text: this.$t('operationsManager')},
        )
      }
      return list;
    }
  },
  i18n: {
    messages: {
      en: {
        adminUser: 'Admin users',
        resetPassword: 'Reset password',
        resetConfirm: 'Are you sure to reset password?',
        resetSuccess: 'Password has been reset successfully, new password was sent to email!',
        resetFailed: 'Reset password failed, please try again!',
        account: 'Account',
        supervisor: 'Supervisor',
        manager: 'Sales manager',
        salesAssistant: 'Sales assistant',
        department: 'Department',
        group: 'Group',
        tech: 'Technician',
        chooseRole: 'Choose role',
        viewer: 'Viewer',
        operationsManager: 'Operations manager',
        pwdLockLabel: "Temporarily lock login from",
        unlock: "Unlock",
        activateConfirm: 'Are you sure to activate this user?',
        activateSuccess: 'Activate successfully!',
        forbidCareTime: 'Forbid caring client until',
        forbidCareCount: 'Number of violation',
        marketing: "Marketing",
        avatar: "Avatar",
        office: "Area",
        chooseOffice: "Choose area",
        chooseDepartment: "Choose department",
        chooseGroup: "Choose group",
        marketingManager: "Marketing Manager",
        ctvCall: "Cộng tác viên ghi âm",
        lookup: "Lookup",
        expired: 'Hết hạn',
        kpiSales: 'KPI sales',
        lastLoginTime: 'Last login time',
        selectCustomerToLookUp: 'Select client to look up'
      },
      vi: {
        adminUser: 'Tài khoản quản trị',
        resetPassword: 'Reset mật khẩu',
        resetConfirm: 'Bạn chắc chắn muốn reset mật khẩu không?',
        resetSuccess: 'Reset mật khẩu thành công, mật khẩu mới đã được gửi qua email!',
        resetFailed: 'Reset mật khẩu thất bại, mời bạn thử lại sau!',
        account: 'Account',
        supervisor: 'Trưởng nhóm',
        manager: 'Quản lý sales',
        salesAssistant: 'Trợ lý sales',
        tech: 'Kỹ thuật',
        chooseRole: 'Chọn quyền',
        viewer: 'Viewer',
        operationsManager: 'TP vận hành',
        pwdLockLabel: "Tạm khoá đăng nhập từ",
        unlock: "Mở khoá",
        activateConfirm: 'Bạn có chắc muốn mở khoá đăng nhập lại tài khoản này',
        activateSuccess: 'Mở khoá đăng nhập thành công',
        forbidCareTime: 'Khoá nhận khách đến',
        forbidCareCount: 'Số lần vi phạm',
        marketing: "Marketing",
        avatar: "Ảnh đại diện",
        office: "Khu vực",
        department: "Phòng ban",
        group: "Nhóm",
        chooseOffice: "Chọn khu vực",
        chooseDepartment: "Chọn phòng ban",
        chooseGroup: "Chọn nhóm",
        marketingManager: "Quản lý Marketing",
        ctvCall: "Cộng tác viên ghi âm",
        lookup: "Tra cứu",
        expired: 'Hết hạn',
        kpiSales: 'KPI sales',
        lastLoginTime: 'Đăng nhập lần cuối lúc',
        selectCustomerToLookUp: 'Chọn khách hàng tra cứu'
      }
    }
  },
  methods: {
    unlock(id) {
      this.$swal({
        icon: 'warning',
        text: this.$t('activateConfirm'),
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.saveLoading = true;
          this.$service.post(`${this.service}/unlock/${id}`).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: this.$t('activateSuccess'),
                toast: true,
                position: 'top-end',
                timer: 5000,
              })
            } else {
              this.$swal({
                icon: 'error',
                text: this.$t('activateFailed'),
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
              this.showForm = false;
            }
          }).finally(() => {
            this.load();
            this.saveLoading = false;
          })
        }
      })
    },
    password: function (id) {
      this.$swal({
        title: this.$t('resetConfirm'),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.delete(this.service + '/' + id + '/password').then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('success'),
                text: this.$t('resetSuccess'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('resetFailed'),
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    getDepartmentList() {
      this.$service.get('/department', {
        params: {
          page: 1, pageSize: 100, status: 0
        }
      }).then(response => {
        this.departmentOptions = [{value: null, text: this.$t('chooseDepartment')}];
        if (response && response.data) {
          response.data.docs.forEach(c => {
            this.departmentOptions.push({value: c._id, text: `${c.name}`})
          })
        }
      })
    },
  },
  mounted() {
    this.getDepartmentList();
  }
};
</script>

<style>
.c-board-table__avatar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 50%;
}

.c-board-table__avatar img {
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
}
</style>